// Shared Google Maps API loader - uses the globally loaded Google Maps script
// The script is loaded via <script> tag in the layout with the API key

console.log("[Google Maps Loader] Module loaded - will use global google.maps.importLibrary")

// Wait for the Google Maps API to be ready
function waitForGoogleMaps() {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps && window.google.maps.importLibrary) {
      console.log("[Google Maps Loader] Google Maps API already loaded")
      resolve()
      return
    }

    console.log("[Google Maps Loader] Waiting for Google Maps API to load...")

    // Check every 100ms for up to 10 seconds
    let attempts = 0
    const maxAttempts = 100

    const interval = setInterval(() => {
      attempts++

      if (window.google && window.google.maps && window.google.maps.importLibrary) {
        console.log("[Google Maps Loader] Google Maps API loaded after", attempts * 100, "ms")
        clearInterval(interval)
        resolve()
      } else if (attempts >= maxAttempts) {
        clearInterval(interval)
        reject(new Error("Google Maps API failed to load within 10 seconds"))
      }
    }, 100)
  })
}

// Wrapper around google.maps.importLibrary that waits for the API to be ready
async function importLibrary(libraryName) {
  await waitForGoogleMaps()
  console.log("[Google Maps Loader] Importing library:", libraryName)
  return window.google.maps.importLibrary(libraryName)
}

// Export the wrapped importLibrary function
export { importLibrary }
